export default __webpack_public_path__ + "media/images/banners/bnr_line-d13371776c8cdd234cd3e1de715427a6.png";